<template>
  <div>
    <div class="text-main-color h2">
      Privacy Policy
    </div>
    <section class="section section-lg">
      <div class="container">
        <div class="row justify-content-center text-center mb-lg">
          <div class="col-lg-12">
            <h2 class="display-3">私隱政策</h2>
            <p class="lead text-muted text-lg-left">滿香脆（以下“本公司”）為了處理與我們提供的服務（以下“本服務”）相關的使用者資訊，包括個人資訊，制定以下私隱政策（以下“本政策”）。</p>
            <h3 class="text-lg-left mt-lg">1. 收集的使用者資訊及收集方式</h3>
            <p class="lead text-muted text-lg-left">在本政策中，“使用者資訊”是指識別使用者的資訊、通信服務上的行為歷史、以及與
              使用者或使用者設備相關的生成或儲存的資訊，這是指本公司根據本政策收集的資
              訊。在本服務中，本公司收集的使用者資訊根據收集方式包括以下內容：</p>
            <p class="lead text-muted text-lg-left">1.1 使用者提供的資訊</p>
            <p class="lead text-muted text-lg-left">為了使用本服務或通過本服務使用，使用者提供的以下資訊：</p>
            <p class="lead text-muted text-lg-left">• 與聯繫資訊相關的姓名、電子郵件地址、郵寄地址、電話號碼等。</p>
            <p class="lead text-muted text-lg-left">• 與支付相關的資訊，例如信用卡或其他付款方式的資訊。</p>
            <p class="lead text-muted text-lg-left">1.2 自動收集的資訊</p>
            <p class="lead text-muted text-lg-left">當使用者訪問或使用本服務時，本公司通過使用常見的技術自動收集以下資訊：</p>
            <p class="lead text-muted text-lg-left">• 使用者設備的類型、操作系統和版本、瀏覽器類型和版本、瀏覽器插件類型和版
              本、使用者的 IP 地址、移動網絡信息、廣告標識符（例如 IDFA 或 GAID）以及其他類
              似的資訊。</p>
            <p class="lead text-muted text-lg-left">• 使用者訪問或使用本服務的時間、頻率和方式，包括瀏覽的網頁、搜尋詞的詳細信
              息、點擊的按鈕、滑動的頁面、顯示的廣告以及其他類似的資訊。</p>
            <h3 class="text-lg-left mt-lg">2. 使用收集的使用者資訊</h3>
            <p class="lead text-muted text-lg-left">本公司使用收集的使用者資訊來提供本服務、改進本服務、保護本公司和其使用者，
              以及遵守法律法規和法律程序的要求。具體而言，本公司使用收集的使用者資訊：</p>
            <p class="lead text-muted text-lg-left">• 向使用者提供本服務，例如處理訂單、回答問題、通知更新、提供技術支持和其他
              類似的服務。</p>
            <p class="lead text-muted text-lg-left">• 改進本服務，例如了解使用者如何使用本服務、維護、保護和改進本服務、開發新
              產品和服務、進行研究和分析以及其他類似的活動。</p>
            <p class="lead text-muted text-lg-left">• 保護本公司和其使用者，例如抵禦欺詐、濫用、非法活動和其他類似的風險。</p>
            <p class="lead text-muted text-lg-left">• 遵守法律法規和法律程序的要求，例如回應法律要求、法院命令或其他類似的要
              求。</p>
            <h3 class="text-lg-left mt-lg">3. 使用者資訊的共享</h3>
            <p class="lead text-muted text-lg-left">本公司僅在以下情況下分享使用者資訊：</p>
            <p class="lead text-muted text-lg-left">• 向本公司的代理、合作夥伴和服務提供商提供所需的資訊，以便他們能夠為本公司
              提供服務。</p>
            <p class="lead text-muted text-lg-left">• 遵守法律法規和法律程序的要求，例如回應法律要求、法院命令或其他類似的要
              求。</p>
            <p class="lead text-muted text-lg-left">• 在本公司出售或轉移業務或資產時，將使用者資訊轉移給相關的第三方。</p>
            <h3 class="text-lg-left mt-lg">4. 使用者資訊的保護</h3>
            <p class="lead text-muted text-lg-left">本公司會實施合理的技術和組織安全措施，以保護收集的使用者資訊，避免未經授權
              的訪問、使用、修改、損毀或損失。儘管本公司會盡最大努力保護使用者資訊，但無
              法保證完全安全。本公司對於使用者資訊被未經授權的訪問、使用、修改、損毀或損
              失，一概不負責。</p>
            <h3 class="text-lg-left mt-lg">5. 使用者權利</h3>
            <p class="lead text-muted text-lg-left">使用者有權：</p>
            <p class="lead text-muted text-lg-left">• 要求本公司更正使用者資訊，如果該資訊不準確。</p>
            <p class="lead text-muted text-lg-left">• 要求本公司刪除使用者資訊，除非本公司有法律法規要求保留該資訊的義務。</p>
            <p class="lead text-muted text-lg-left">• 撤回使用者授權使用使用者資訊的同意。</p>
            <p class="lead text-muted text-lg-left">• 提出有關使用者資訊的投訴。</p>
            <h3 class="text-lg-left mt-lg">6. 第三方網站和服務</h3>
            <p class="lead text-muted text-lg-left">本服務可能包含指向第三方網站和服務的連結，這些第三方網站和服務有自己的私隱
              政策，本公司不對這些第三方網站和服務的私隱政策負責。</p>
            <h3 class="text-lg-left mt-lg">7. 本政策的變更</h3>
            <p class="lead text-muted text-lg-left">本公司可能會不時修改本政策，以反映本公司在使用者資訊方面的實踐和法律法規的
              變化。如有重大變更，本公司將通過本服務發布通知。</p>
            <h3 class="text-lg-left mt-lg">8. 聯繫我們</h3>
            <p class="lead text-muted text-lg-left">如果使用者對本政策有任何問題或疑慮，請通過以下方式聯繫本公司：</p>
            <p class="lead text-muted text-lg-left">• 電子郵件地址：</p>
            <p class="lead text-muted text-lg-left">本政策於 2024 年 6 月 25 日生效。</p>
          </div>
        </div>

      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "privacy_policy"
}
</script>

<style scoped>

</style>
